import { useI18n, t } from "@bookingcom/lingojs-react";
import useRouteName from "hooks/useRouteName";
import { useMemo } from "react";

export type HiddenFeesControllerProps = {};

export function useHiddenFeesController() {
  const i18n = useI18n();
  const routeName = useRouteName();

  const isCheckoutStep = useMemo(
    () => ["checkout-payment", "pb-order-details", "pb-checkout-payment"].includes(routeName),
    [routeName]
  );

  const text = useMemo(
    () =>
      isCheckoutStep
        ? i18n.trans(t("flights_price_details_no_hidden_fees"))
        : i18n.trans(t("flights_funnel_no_hidden_fees_usp")),
    [i18n, isCheckoutStep]
  );

  return {
    text
  };
}
